import request from '../../../api/request';
import {
  AttendanceListResponse,
  Teacher,
  IdentificationTypesResponse,
} from './types';
import dayjs from 'dayjs';
import { clean } from 'rut.js';
import { IdentificationDocumentCode } from '../../PaymentHub/enums/identification-document-code.enum';

const ATTENDANCES = {
  GET_ATTENDANCES_LIST: () =>
    `maintainers-portal/teacher-management/teacher-attendances`,
  GET_IDENTIFICATION_TYPE_LIST: () =>
    `maintainers-portal/teacher-management/teacher-attendances/identification-types`,
  GET_SEACRHED_USER_BY_IDENTIFICATION: () =>
    `maintainers-portal/teacher-management/teacher-attendances/search`,
  POST_OBSERVATION: () =>
    `maintainers-portal/teacher-management/teacher-attendances/update-observation`,
};

export function getAttendanceList(
  teacherId: number,
  page: number,
  initDate: dayjs.Dayjs,
) {
  const params = {
    teacherId,
    page,
    initDate: initDate.format('YYYY/MM/DD'),
    endDate: dayjs().format('YYYY/MM/DD'),
  };

  return request<AttendanceListResponse>(ATTENDANCES.GET_ATTENDANCES_LIST(), {
    params,
  });
}

export function getIdentificationTypes() {
  return request<IdentificationTypesResponse>(
    ATTENDANCES.GET_IDENTIFICATION_TYPE_LIST(),
  );
}

export function getSearchedUserByIdentification(
  identificationTypeId: string,
  identification: string,
  countryId: string | null,
) {
  const cleanIdentification = clean(identification);
  const params = {
    identificationTypeId,
    identification:
      identificationTypeId === IdentificationDocumentCode.CL_RUT
        ? cleanIdentification
        : identification,
    countryId:
      identificationTypeId === IdentificationDocumentCode.Passport
        ? countryId
        : null,
  };
  return request<Teacher>(ATTENDANCES.GET_SEACRHED_USER_BY_IDENTIFICATION(), {
    params,
  });
}

export function postUpdateObservation(
  teacherId: number,
  lessonId: number,
  justificationStatus: string,
  justification: string | null,
  observation: string | null,
  teacherFilesIds: number[],
  adminFilesIds: number[],
) {
  const data = {
    teacherId,
    lessonId,
    justificationStatus,
    justification,
    observation,
    teacherFilesIds,
    adminFilesIds,
  };
  return request(ATTENDANCES.POST_OBSERVATION(), {
    method: 'POST',
    data,
  });
}
